import {
  AdditionalMeter,
  AzureOfferPlan,
} from '../../../modules/privateOffer/types'
import { useStyles } from './PlanMeteringDimensions.styles'
import { useStyles as usePricingStyles } from '../MicrosoftViewPricing.styles'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material'
import clsx from 'clsx'
import {
  isNonEmptyNumber,
  numberFormatWithPrecision,
  ViewValueWithTruncate,
} from '@labrav/common'

interface PlanMeteringDimensionsProps {
  plan: AzureOfferPlan
}

export const PlanMeteringDimensions = ({
  plan,
}: PlanMeteringDimensionsProps) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()

  const customMeters = plan.pricing?.customMeters?.meters || {}
  const meterEntries = Object.entries(customMeters)

  if (meterEntries.length === 0) {
    return null
  }

  return (
    <div className={classes.container}>
      <div className={pricingClasses.subHeading}>Metering Dimensions</div>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell className={classes.headerCell}>Name</TableCell>
              <TableCell className={classes.headerCell}>Unit</TableCell>
              <TableCell
                className={clsx(classes.headerCell, classes.textRight)}
              >
                Price per Unit
              </TableCell>
              <TableCell
                className={clsx(classes.headerCell, classes.textRight)}
              >
                Base quantity
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {meterEntries.map(([meterKey, meterValue]) => {
              return (
                <TableRow key={meterKey} className={classes.dataRow}>
                  <TableCell className={classes.dataCell}>
                    <ViewValueWithTruncate
                      value={meterValue.meteringDimensionName || meterKey}
                    />
                  </TableCell>
                  <TableCell className={classes.dataCell}>
                    {meterValue?.unitOfMeasure || 'N/A'}
                  </TableCell>
                  <TableCell
                    className={clsx(classes.dataCell, classes.textRight)}
                  >
                    <DisplayNumberValue
                      value={meterValue?.pricePerPaymentInUsd}
                      isPrice
                      shouldFormat
                    />
                  </TableCell>
                  <TableCell
                    className={clsx(classes.dataCell, classes.textRight)}
                  >
                    {getBaseQuantity(meterValue)}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export const DisplayNumberValue = ({
  value,
  isPrice,
  shouldFormat,
  isUnlimited,
  isPrecisionDigit = true,
}: {
  value?: number
  isPrice?: boolean
  shouldFormat?: boolean
  isUnlimited?: boolean
  isPrecisionDigit?: boolean
}) => {
  const { classes } = useStyles()

  if (isUnlimited) {
    return <span className={classes.numberValue}>Unlimited</span>
  }

  return (
    <div>
      {isPrice && isNonEmptyNumber(value) ? (
        <span className={classes.currency}>$</span>
      ) : (
        ''
      )}
      <span className={classes.numberValue} data-testid={'number-value'}>
        {isNonEmptyNumber(value)
          ? shouldFormat
            ? numberFormatWithPrecision(value!, 5, isPrecisionDigit)
            : value
          : '-'}
      </span>
    </div>
  )
}

export const getBaseQuantity = (meterValue: AdditionalMeter) => {
  if (meterValue?.includedQuantities?.length > 0) {
    if (meterValue.includedQuantities[0]?.isInfinite) {
      return 'Unlimited'
    }

    return meterValue.includedQuantities[0]?.quantity
  }
  return ''
}
